"use client";

import { useEffect, useState } from "react";
import { fetchPromos } from "@/utils/api/promos";
import { countryName } from "@/features/landing/utils/country-name";


export default function PromosPage() {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

const getCountryName = (code) => {
  if (!code) return "—";
  return countryName(code);
};

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchPromos();
        setPromos(data.list || []);
      } catch (err) {
        setError(err.message || "Failed to load promos");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const renderPromoCard = (promo) => {
    const desc =
      promo.description?.find(d => d.language === "en")?.description ??
      promo.description?.[0]?.description ??
      "No description";

    const terms =
      promo.description?.find(d => d.language === "en")?.terms ??
      promo.description?.[0]?.terms ??
      null;

    const start = promo.startAt ? new Date(promo.startAt).toLocaleDateString("en-GB") : "—";
    const end = promo.endAt ? new Date(promo.endAt).toLocaleDateString("en-GB") : "—";

    const country = getCountryName(promo.country);
    const brand = promo.brand?.brandName || "Unknown Brand";

    return (
      <div
        key={promo.id}
        className="p-4 border border-border rounded-md bg-surface shadow animate-fadeIn"
      >
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-textPrimary">{brand}</h2>
          <span className="text-xs text-textSecondary">{country}</span>
        </div>

        <p className="text-sm text-textSecondary font-medium mt-1">{desc}</p>

        {terms && (
          <p className="text-xs mt-1 italic text-textPrimary">
            {terms}
          </p>
        )}

        <p className="text-xs mt-2 text-textSecondary">
          📅 {start} – {end}
        </p>

        {(promo.minValue || promo.maxValue) && (
          <p className="text-xs text-textSecondary mt-1">
            💰 Topup range: {promo.minValue ?? "?"} – {promo.maxValue ?? "?"}
          </p>
        )}
      </div>
    );
  };

  const EmptyState = () => (
    <div className="flex items-center justify-center h-[60vh]">
      <div className="text-center">
        <div className="text-4xl mb-3">🎁</div>
        <h2 className="text-lg font-semibold text-textPrimary">
          No promos available right now
        </h2>
        <p className="text-textSecondary mt-2">
          Check back later for exciting offers!
        </p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 p-4 space-y-6">
        <h1 className="text-xl font-bold text-primary">🔥 Active Promotions</h1>

        {loading && <div>Loading promos...</div>}
        {error && <div className="text-red-500">Error: {error}</div>}

        {!loading && !error && (
          promos.length === 0
            ? <EmptyState />
            : <div className="space-y-4">{promos.map(renderPromoCard)}</div>
        )}
      </main>
    </div>
  );
}
